import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getEmissionById } from "@store/action/planning/EmissionAction";
import { useTranslation } from "react-i18next";
import { secondsToTime } from "@store/action/GlobalAction";
import { Badge } from "reactstrap";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import BreadCrumbs from "@components/breadcrumbs/index1";
import TabsCentered from "./Tabs";
import Comment from "./Comment";
import Filter from "../Filter";

const EmissionId = () => {
  const emissions = useSelector((state) => state.emissions);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const id = useParams().id;
  const shareUrl = window.location.href;
  useEffect(() => {
    dispatch(getEmissionById(id));
  }, [dispatch, id]);

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={`${t("Details")}`} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              dispatch={dispatch}
              store={emissions}
              setCurrentPage={() => {}}
              path="emissions"
            />
            {emissions?.em && (
              <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="artist_wrapper_content ms_cover">
                      <img
                        src={emissions.em.picture}
                        className="img-responsive"
                        height="250px"
                        alt="img"
                      />
                      <div className="artist_wrapper_text">
                        <div className="artist_wrapper_left">
                          <h1>{emissions.em.name}</h1>
                          <p>
                            {t("Category")} :
                            {emissions.em.categories?.map((el, i) => (
                              <Badge
                                className="ms-1"
                                color="secondary"
                                key={i}
                                pill
                              >
                                <Link to={`/emissions/category/${el.slug}`}>
                                  {el.name}
                                </Link>
                              </Badge>
                            ))}
                          </p>

                          <p>
                            {" "}
                            {t("Description")}: {emissions?.em?.description}
                          </p>
                          <p>
                            {t("Classification")}:
                            <Link
                              to={`/emissions/classification/${emissions?.em?.classification?.id}/${emissions?.em?.classification?.name}`}
                            >
                              {emissions?.em?.classification?.name}
                            </Link>
                          </p>
                          <p>
                            {t("Language")} : {emissions?.em?.language?.name}
                          </p>
                          <p>
                            {t("Tags :")}
                            {emissions.em.tags?.map((el, i) => (
                              <Badge
                                className="ms-1"
                                color="secondary"
                                key={i}
                                pill
                              >
                                <Link to={`/emissions/tag/${el.slug}`}>
                                  {el.name}
                                </Link>
                              </Badge>
                            ))}
                          </p>
                          <p>
                            {t("Episodes")}:{emissions.em.episodes?.length}
                          </p>
                          <div className="artist_btn ms_cover">
                            <div className="lang_apply_btn">
                              <a>
                                <i className="flaticon-clock"></i>
                                {secondsToTime(emissions.em.max_duration_sec)}
                              </a>
                            </div>
                            <div className="cancel_wrapper">
                              <ul
                                className="blog-icon-podcast"
                                style={{
                                  textAlign: "center",
                                  marginTop: "8px",
                                  marginLeft: "15px",
                                }}
                              >
                                <li>
                                  <FacebookShareButton url={shareUrl}>
                                    <FacebookIcon size={30} round={true} />
                                  </FacebookShareButton>
                                </li>

                                <li>
                                  <TwitterShareButton url={shareUrl}>
                                    <TwitterIcon size={30} round={true} />
                                  </TwitterShareButton>
                                </li>
                                <li>
                                  <WhatsappShareButton url={shareUrl}>
                                    <WhatsappIcon size={30} round={true} />
                                  </WhatsappShareButton>
                                </li>
                                <li>
                                  <FacebookMessengerShareButton url={shareUrl}>
                                    <FacebookMessengerIcon
                                      size={30}
                                      round={true}
                                    />
                                  </FacebookMessengerShareButton>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <TabsCentered t={t} />

                <Comment t={t} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmissionId;
